// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lv-0";
export var assigneeDetails = "_lv-1";
export var assigneeInfo = "_lv-2";
export var dropdownContainer = "_lv-4";
export var dropdownImage = "_lv-5";
export var editAssigneeInfo = "_lv-3";
export var editAssigneeModalContainer = "_lv-6";
export var hidden = "_lv-8";
export var input = "_lv-7";